var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap justify-content-center gap-2 domains"},_vm._l((_vm.rowData.domains),function(domain){return _c('b-badge',{key:domain,attrs:{"variant":"primary"}},[_vm._v(" "+_vm._s(domain)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }